var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wrapper wrapper-content ', {'animated': _vm.animated}, _vm.$root.animacaoPadrao]},[(_vm.aluno)?_c('curso-lista'):_vm._e(),_vm._v(" "),(_vm.fornecedor || _vm.fornecedorWeb || _vm.fornecedorWebNovo)?_c('div',[(this.configuracao.instrucoesFornecedor)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.configuracao.instrucoesFornecedor)}}):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38de5d5d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/dashboard/Dashboard.vue
// module id = 1967
// module chunks = 0